<template>
  <v-container id="create" fluid>
    <v-row>
      <v-col cols="3">
        <ClubController/>
      </v-col>
      <v-col cols="9">
        <ClubMenu/>
        <RouterView/>
      </v-col>
    </v-row>

    <!-- Button for new trade !-->
    <v-speed-dial style="z-index: 10;" v-if="$store.state.clubMember.rol !== 'MEMBER'"
                  v-model="actionActivator" open-on-hover direction="top" fixed bottom right class="mr-7 mb-7">
      <template v-slot:activator>
        <v-btn :color="`#${$store.state.clubMember.club.primaryColor}`" dark fab>
          <v-icon v-if="actionActivator" color="#FFFFFF">fa-times</v-icon>
          <v-icon color="#FFFFFF" v-else>fa-plus</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark color="#111111" @click="addTournament"><v-icon color="white">fa-trophy</v-icon></v-btn>
      <v-btn fab dark color="#111111" @click="addChannel"><v-icon color="white">fa-layer-group</v-icon></v-btn>
      <v-btn fab dark color="#111111" @click="overlayAddEvent = true"><v-icon color="white">fa-calendar-alt</v-icon></v-btn>
      <v-btn fab dark color="#111111" @click="overlayAddPost = true"><v-icon color="white">fa-sticky-note</v-icon></v-btn>
    </v-speed-dial>

    <!-- Overlay for add post !-->
    <v-overlay :value="overlayAddPost">
      <AddPost @closeWindow="overlayAddPost = false"/>
    </v-overlay>
    <!-- Overlay for add event !-->
    <v-overlay :value="overlayAddEvent">
      <AddEvent @closeWindow="overlayAddEvent = false"/>
    </v-overlay>
    <!-- Overlay for add channel !-->
    <v-overlay :value="overlayAddChannel">
      <AddChannel :arePublicChannelsUnavailable="arePublicChannelsUnavailable" :arePrivateChannelsUnavailable="arePrivateChannelsUnavailable"
        @closeWindow="overlayAddChannel = false"/>
    </v-overlay>
    <!-- Overlay for add tournament !-->
    <v-overlay :value="overlayAddTournament">
      <AddTournament :featurePermissionInfo="tournamentPermissionInfo" @closeWindow="overlayAddTournament = false"/>
    </v-overlay>

    <v-overlay v-model="overlayUnavailableFeature">
      <UnavailableFeature :hasCloseWindowAction="true" @closeWindow="overlayUnavailableFeature = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import ClubController from "@/views/Community/components/ClubController";
import ClubMenu from "@/views/Community/components/ClubMenu";
import AddPost from "@/views/Community/components/AddPost";
import AddEvent from "@/views/Community/components/AddEvent";
import AddTournament from "@/views/Community/components/AddTournament";
import AddChannel from "@/views/Community/components/AddChannel";
import UnavailableFeature from './../components/UnavailableFeature';
import TournamentRepository from '../../../repositories/tournament';
import ClubRepository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "ClubIndex",
  components: {AddChannel, AddTournament, AddEvent, AddPost, ClubMenu, ClubController, UnavailableFeature},
  mounted() {
    this.init();
  },
  data() {
    return {
      arePublicChannelsUnavailable: true,
      arePrivateChannelsUnavailable: true,
      isTournamentCreationUnavailable: true,
      tournamentPermissionInfo: null,
      actionActivator: false,
      overlayAddPost: false,
      overlayAddTournament: false,
      overlayAddEvent: false,
      overlayAddChannel: false,
      overlayUnavailableFeature: false,
    };
  },
  methods: {
    ...mapMutations(['setClubTournaments', 'setClubPermissions']),
    async init() {
      // Verifying if refreshing
      if (this.$store.state.clubMember === undefined || this.$store.state.clubMember === null)
        this.$router.push('/community');
      await ClubRepository.getClubPermissions(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400)
          this.setClubPermissions(response.data);
      });
      await TournamentRepository.getTournamentsByClubId(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400)
          this.setClubTournaments(response.data);
      });
      this.validateFeaturesAvailable();
    },
    validateFeaturesAvailable() {
      let permissions = this.$store.state.clubPermissions;
      for(let permission of permissions) {
        if(permission.clubFeature.name == 'PUBLIC_CHANNELS') {
          this.arePublicChannelsUnavailable = false;
        } else if (permission.clubFeature.name == 'PRIVATE_CHANNELS') {
          this.arePrivateChannelsUnavailable = false;
        } else if (permission.clubFeature.name == 'TOURNAMENT_CREATION') {
          this.isTournamentCreationUnavailable = false;
          this.tournamentPermissionInfo = permission;
        }
      }
    },
    addChannel() {
      if(this.arePublicChannelsUnavailable && this.arePrivateChannelsUnavailable) {
        this.overlayUnavailableFeature = true;
      } else {
        this.overlayAddChannel = true;
      }
    },
    addTournament() {
      if (this.isTournamentCreationUnavailable) {
        this.overlayUnavailableFeature = true;
      } else {
        this.overlayAddTournament = true;
      }
    }
  }
}
</script>

<style scoped>
  /* This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>
